const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M43 47V48M30 48V47V48Z",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.0002 30H26V43H19",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26 32C27 32 28 32 29 32C31 32 32 29 33 29H37C38 29 39 30 39 31",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.9999 32C40.6521 32 42.9782 32 42.9782 32C44.9564 32 44.9999 35 42.9782 35C44.9999 35 44.9999 38 42.9782 38C45.0002 38 45.0001 41 42.9781 41C44.9998 41 44.9782 44 42.9782 44C40.9782 44 33.9999 44 31.9999 44C30 44 28 42 25.9999 42",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.9575 35.0028H37.992",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43 41.0028H37.992",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.9575 38.0028H37.992",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.99482 1V0M17.9976 0V1V0Z",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9992 18H21.9985V5H29",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9983 16C20.9981 16 19.9979 16 18.9977 16C16.9973 16 15.9971 19 14.9969 19H10.996C9.99582 19 8.99561 18 8.99561 17",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.9965 16C7.34335 16 5.01677 16 5.01677 16C3.03811 16 2.99457 13 5.01677 13C2.99466 13 2.9946 10 5.01677 10C2.99437 10 2.99442 7 5.01685 7C2.99469 7 3.01634 4 5.01677 4C7.01719 4 13.9969 4 15.9973 4C17.9977 4 19.9981 6 21.9986 6",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.0376 12.9972H10.0042",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.99512 6.99719H10.0042",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.0376 9.99719H10.0042",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M47 5H48M48 18H47H48Z",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30 25.9998V22H43V29",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 22C32 21 32 20 32 19C32 17 29 16 29 15V11C29 10 30 9 31 9",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32 12.0001C32 7.34791 32 5.02182 32 5.02182C32 3.04358 35 3.00005 35 5.02182C35 3.00014 38 3.00008 38 5.02182C38 2.99985 41 2.9999 41 5.0219C41 3.00016 44 3.02182 44 5.02182C44 7.02182 44 14.0001 44 16.0001C44 18 42 20 42 22.0001",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M35.0029 5.04248V10.008",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.0029 5V10.008",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.0029 5.04248V10.008",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 43.0051H0M0 30.0023H1H0Z",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18 22.0008V26.0015H5V19",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 26.0015C16 27.0017 16 28.0019 16 29.0021C16 31.0025 19 32.0027 19 33.0029V37.0038C19 38.004 18 39.0042 17 39.0042",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 36.0034C16 40.6566 16 42.9831 16 42.9831C16 44.9618 13 45.0053 13 42.9831C13 45.0052 10 45.0053 10 42.9831C10 45.0055 7 45.0055 7 42.983C7 45.0052 4 44.9836 4 42.9831C4 40.9827 4 34.003 4 32.0026C4 30.0022 6 28.0018 6 26.0013",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.9971 42.9626V37.996",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.99707 43.0051V37.996",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.99707 42.9626V37.996",
  stroke: "#0073F7",
  strokeWidth: 2,
  strokeLinecap: "round"
}));
var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 48,
  height: 48,
  fill: "white"
})));
function SvgRisks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisks);
export default __webpack_public_path__ + "static/media/risks.8ccfb0a3.svg";
export { ForwardRef as ReactComponent };